module.exports = __webpack_public_path__ + "img/home-services-02.31226835.webp";